module.exports = __webpack_public_path__ + "img/windows.ff3cf8a7.svg";